import { render } from "./chooseFamily.vue?vue&type=template&id=32a5484a"
import script from "./chooseFamily.vue?vue&type=script&lang=js"
export * from "./chooseFamily.vue?vue&type=script&lang=js"
script.render = render

export default script